var _desc, _defs, _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 37,
    viewBox: "169 201 26 37",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 182.32 219.27)",
    id: "RlcwsLpa_xNGR30SuFLju",
    clipPath: "url(#CLIPPATH_1)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 -174.64 197) translate(-512, -384)",
    id: "clip-Presenter_-_no_notifications",
    d: "M 0 0 L 1024 0 L 1024 768 L 0 768 z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -7.143 12.5 L 7.143 0 L -7.143 -12.5",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.279255991f2f3024c00a0476fb86e785.svg";
export { ForwardRef as ReactComponent };